import src from "IMAGE";
export default { src, width: 174, height: 25, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJUlEQVR42mOwsDDvMTQ0yDI2NqrQ19cL19HRMdPVBWN9IyNDUwB+UwcY2vuBjQAAAABJRU5ErkJggg=="};
